<forge-card appearance="outlined" telemetry="Card-ToDo-UtilityBilling" no-padding>
  <forge-toolbar fxLayout="column">
    <h2 slot="start" class="forge-typography--heading4">To Do</h2>
  </forge-toolbar>

  <div fxLayout="column" class="metadata-padding">

    @if (!hasItems) {
      <div fxFlex fxLayoutAlign="center">
        You have no To Do Items
      </div>
    }

    @if (hasItems) {
      @for (item of displayItems; track item) {
        <div fxLayout="row" fxLayoutAlign="space-between center" class="row">
          <div fxFlex="30">
            @if (!isCustom(item)) {
              <a (click)="openEntity(item)" [ngClass]="getClass(item)" tabindex="0">
                {{item.EntityNumber}}
              </a>
            }
            @if (isCustom(item)) {
              <div [ngClass]="getClass(item)" class="padding">
                {{item.EntityNumber}}
              </div>
            }
          </div>
          <div fxFlex="40" [ngClass]="pastDue(item)" class="description">
            {{item.ItemDescription}}
          </div>
          <div fxFlex="20" [ngClass]="getClass(item)">
            {{item.DueDate}}
          </div>
          <forge-icon-button (click)="completed(item)"
            [attr.aria-label]="getAriaLabel(item)" [attr.telemetry]="getAriaLabel(item)">
            <forge-tooltip position="bottom">Complete</forge-tooltip>
            <forge-icon name="check_circle"></forge-icon>
          </forge-icon-button>
          @if(item.Saving)
            {
            <forge-linear-progress  mode="indeterminate"></forge-linear-progress>
          }
        </div>
      }
    }

    @if (canShowMore) {
      <div>
        <forge-divider></forge-divider>
        <forge-icon-button (click)="showMore($event)">
          <forge-tooltip position="bottom">Show more</forge-tooltip>
          <forge-icon name="more_horiz"></forge-icon>
        </forge-icon-button>
      </div>
    }
  </div>

  <div fxLayoutAlign="end center" class="tt-margin--all">
    @if(canUndo) {
      <forge-icon-button (click)="undo()" class="tt-margin--right">
        <forge-tooltip position="bottom">Undo add to-do item</forge-tooltip>
        <forge-icon name="undo"></forge-icon>
      </forge-icon-button>
    }

    <forge-icon-button variant="filled" (click)="addTodo()" telemetry="Submission-Add-ToDo-UtilityBilling">
      <forge-tooltip position="bottom">Add To Do Item</forge-tooltip>
      <forge-icon style="--forge-icon-color: var(--forge-theme-text-high-inverse);" name="add"></forge-icon>
    </forge-icon-button>
  </div>
</forge-card>